module.exports = __webpack_public_path__ + "img/iconLiShiWuLiaoPanDian.f4609b48.svg";